// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_WVvd4","content":"content_X2ad4","radioGroup":"radioGroup_zHxa-","footer":"footer_hzaY-"};